/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { GetUnreadNotificationsCountQueryResponse } from '../../types/GetUnreadNotificationsCount'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getUnreadNotificationsCount } from '../../clients/getUnreadNotificationsCount'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUnreadNotificationsCountQueryKey = () =>
  [{ url: '/api/v1/notifications/unread-count/' }] as const

export type GetUnreadNotificationsCountQueryKey = ReturnType<
  typeof getUnreadNotificationsCountQueryKey
>

export function getUnreadNotificationsCountQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getUnreadNotificationsCountQueryKey()
  return queryOptions<
    GetUnreadNotificationsCountQueryResponse,
    ResponseErrorConfig<Error>,
    GetUnreadNotificationsCountQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUnreadNotificationsCount({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Count of unread notifications for the current user
 * {@link /api/v1/notifications/unread-count/}
 */
export function useGetUnreadNotificationsCount<
  TData = GetUnreadNotificationsCountQueryResponse,
  TQueryData = GetUnreadNotificationsCountQueryResponse,
  TQueryKey extends QueryKey = GetUnreadNotificationsCountQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUnreadNotificationsCountQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getUnreadNotificationsCountQueryKey()

  const query = useQuery(
    {
      ...getUnreadNotificationsCountQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
